import React from "react";
import './Styles/components.css';
import './Styles/Footer.css';
import google from '../images/googleplay.png'
import appstore from '../images/googleapp.png'

const Footer = (props,{ children, onMouseOver, onMouseLeave, onMouseDown, onMouseUp, className, ...restProps }) => {

      return (
        <><svg className="wave"  viewBox="0 0 1440 140" version="1.1" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0"><stop stopColor="rgba(243, 106, 62, 1)" offset="0%"></stop><stop stopColor="rgba(255, 179, 11, 1)" offset="100%"></stop></linearGradient></defs><path fill="var(--footer-color)" d="M0,14L40,14C80,14,160,14,240,28C320,42,400,70,480,88.7C560,107,640,117,720,119C800,121,880,117,960,100.3C1040,84,1120,56,1200,39.7C1280,23,1360,19,1440,18.7C1520,19,1600,23,1680,39.7C1760,56,1840,84,1920,84C2000,84,2080,56,2160,37.3C2240,19,2320,9,2400,18.7C2480,28,2560,56,2640,58.3C2720,61,2800,37,2880,25.7C2960,14,3040,14,3120,18.7C3200,23,3280,33,3360,44.3C3440,56,3520,70,3600,70C3680,70,3760,56,3840,58.3C3920,61,4000,79,4080,77C4160,75,4240,51,4320,42C4400,33,4480,37,4560,51.3C4640,65,4720,89,4800,86.3C4880,84,4960,56,5040,39.7C5120,23,5200,19,5280,21C5360,23,5440,33,5520,51.3C5600,70,5680,98,5720,112L5760,126L5760,140L5720,140C5680,140,5600,140,5520,140C5440,140,5360,140,5280,140C5200,140,5120,140,5040,140C4960,140,4880,140,4800,140C4720,140,4640,140,4560,140C4480,140,4400,140,4320,140C4240,140,4160,140,4080,140C4000,140,3920,140,3840,140C3760,140,3680,140,3600,140C3520,140,3440,140,3360,140C3280,140,3200,140,3120,140C3040,140,2960,140,2880,140C2800,140,2720,140,2640,140C2560,140,2480,140,2400,140C2320,140,2240,140,2160,140C2080,140,2000,140,1920,140C1840,140,1760,140,1680,140C1600,140,1520,140,1440,140C1360,140,1280,140,1200,140C1120,140,1040,140,960,140C880,140,800,140,720,140C640,140,560,140,480,140C400,140,320,140,240,140C160,140,80,140,40,140L0,140Z"></path></svg>
        <div {...restProps} className={`theme-div Footer-div ${className}`}>
            
          <div className={`theme-div Footer-div-0`}>
            {/* Google play store link */}
            
            {/* App Store link */}
            <a className={`theme-a Footer-a-0`} href={props.appstore}>
              <img className={`theme-img Footer-img`} alt="download app from app store"
                src={appstore} />
            </a>
          </div>
          <div className={`theme-div Footer-div-1`}>
            <a className={`theme-a Footer-a-1`} href={props.faceebook}>
              <img className={`theme-svg Footer-svg`} src="https://img.icons8.com/arcade/64/null/facebook-new.png" alt="Facebook" />
            </a>
            <a className={`theme-a Footer-a-2`} href={props.istagram}
             >
             <img className={`theme-svg Footer-svg-0`} src="https://img.icons8.com/fluency/48/null/instagram-new.png" alt="Instagram"/>
             
            </a>
          </div>
          <div className={`theme-div Footer-div-2`}>
            <p className={`theme-p Footer-p`}>
              <b className={`theme-b Footer-b`}><span children="POWERED BY" /></b>
              <a className={`theme-a Footer-a-3`} href={props.companylink} ><span
                   />{props.companyname}</a>
              <span children=" | " />
              <a className={`theme-a Footer-a-4`} href={props.policylink}><span
                  children="Privacy Policy" /></a>
              <span children=" | " />
              <a className={`theme-a Footer-a-5`} href={props.FAQSlink}><span children="FAQS" /></a>
            </p>
           </div>
        </div>
        </>
      )
    };
  Footer.defaultProps={
    playstore:"",
    appstore:"",
    policylink:"",
    companylink:"",
    companyname:"Company",
    FAQSlink:"",
    facebook:"",
    instagram:"",

  }
  export default Footer;